import { createSelector } from 'reselect';
import { SCOPE } from './types';
import { get } from 'lodash';

const selector = state => get(state, SCOPE);

export default selector;

export const initializingSelector = createSelector(
  selector,
  store => store.initializing,
);
